import { fieldUpdater, partialUpdater } from '@shared/Frontend/utils/updaters'
import { AsyncState, BasicUpdater, Maybe, Template, unit, Unit } from 'ballerina-core'
import React, { ReactNode } from 'react'
import { RecentContentBlockContext, RecentContentBlockState } from './recentContent.state'
import { BlocksView } from '../blocks.template'
import { Teaser, TeaserKind, Teasers } from '../../teasers/teasers.state'
import { getTeasers } from '../../teasers/teasers.api'
import { AsyncLoaderTemplate } from '@shared/Frontend/asyncLoader'
import { CMSPageView } from '../../cmsPage.template'
import { Block } from '../blocks.state'

export type RecentContentBlockView = {
  RecentContentBlock: BlocksView["RecentContentBlock"]
  Loader: CMSPageView["Loader"]
}

export const RecentContentBlockTemplate = Template.Default<
  RecentContentBlockContext,
  RecentContentBlockState,
  Unit,
  RecentContentBlockView
>(({ context, setState, foreignMutations, view }) => {
  return <>
    <TeasersLoaderTemplate
      context={{
        ...context.items,
        promise: () =>
          getTeasers({
            type: context.linkedContent,
            pageSize: 3,
          }).then(response => response?.items),
      }}
      setState={updater => setState(s0 => fieldUpdater<RecentContentBlockState>()("items")(updater)(s0))}
      foreignMutations={unit}
      view={unit}
    />

    {AsyncState.Operations.hasValue(context.items) && context.items.value ? (
      <view.RecentContentBlock
        {...context}
        {...foreignMutations}
      />
    ) : (
      <view.Loader type="inline" />
    )}
  </>
})

const TeasersLoaderTemplate = AsyncLoaderTemplate<Maybe<Array<Teaser>>>()

export const MappedRecentContentBlockTemplate = RecentContentBlockTemplate.mapState<Block>(
  (updater) =>
    (state): Block =>
      state.kind == 'recentContentBlock' ? partialUpdater<RecentContentBlockState>(updater)(state) : state
)
